module.exports = __webpack_public_path__ + "img/28_47.5aac0602.png";